
<div class="modal-dialog confirm-dialog">
  <div class="modal-content">
    <form #orderForm="ngForm" (ngSubmit)="save()">
      <div class="modal-header">
        <h4 class="modal-title">Create a Order</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div class="row">
          <div class="form-group col">
            <label class="required" for="nameField">Order Name</label>
            <input class="form-control" id="nameField" type="text" [(ngModel)]="orderName" name="name" maxlength="100" required>
          </div>
        </div>
        <div class="row" *ngIf="availableSites?.length">
          <div class="form-group col">
            <label class="required" for="selectedSiteId">Site:</label>
            <select class="form-control" id="selectedSiteId" [(ngModel)]="siteId" name="selectedSiteId" required>
              <option *ngFor="let property of availableSites" [value]="property.id">{{property.name}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="submit">Save</button>
        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>